import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialProductionPage() {
    const navigate = useNavigate();

    // Fake data for urgency
    const load = 92;
    const nextSlot = "14 Février";
    const remainingSlots = 2;

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            <div style={{ width: '100%', maxWidth: 800, textAlign: 'center' }}>
                <h1 style={{ fontSize: '3rem', fontWeight: 800, marginBottom: 10 }}>🚧 Production Rush</h1>
                <p style={{ opacity: 0.6, fontSize: '1.2rem', marginBottom: 60 }}>État des lieux de la charge de production en temps réel.</p>

                {/* Gauge Area */}
                <div style={{ position: 'relative', marginBottom: 60 }}>
                    <div style={{ height: 40, background: '#334155', borderRadius: 20, overflow: 'hidden' }}>
                        <div style={{
                            width: `${load}%`, height: '100%', background: 'linear-gradient(90deg, #22c55e, #eab308, #ef4444)',
                            borderRadius: 20, transition: 'width 2s ease-out'
                        }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, fontWeight: 700, fontSize: '0.9rem', color: '#94a3b8' }}>
                        <span>Calme (0%)</span>
                        <span>Surchargé (100%)</span>
                    </div>
                    <div style={{ position: 'absolute', top: -50, right: 0, fontSize: '2rem', fontWeight: 900, color: '#ef4444' }}>
                        {load}% CAPACITY
                    </div>
                </div>

                {/* Slot Cards */}
                <div style={{ display: 'flex', gap: 20 }}>
                    <div style={{ flex: 1, padding: 30, background: '#1e293b', borderRadius: 24, border: '1px solid rgba(255,255,255,0.1)' }}>
                        <div style={{ fontSize: '1rem', opacity: 0.6, textTransform: 'uppercase', marginBottom: 10 }}>Prochain Créneau</div>
                        <div style={{ fontSize: '2.5rem', fontWeight: 900, color: 'white' }}>{nextSlot}</div>
                    </div>
                    <div className="animate-pulse-red" style={{ flex: 1, padding: 30, background: 'rgba(239, 68, 68, 0.1)', borderRadius: 24, border: '2px solid #ef4444', color: '#ef4444' }}>
                        <div style={{ fontSize: '1rem', opacity: 0.8, textTransform: 'uppercase', marginBottom: 10 }}>Places Restantes</div>
                        <div style={{ fontSize: '2.5rem', fontWeight: 900 }}>{remainingSlots} ONLY</div>
                    </div>
                </div>

                <div style={{ marginTop: 50, padding: 20, background: 'rgba(255,255,255,0.05)', borderRadius: 16, fontSize: '1.1rem' }}>
                    ⚠️ <strong>Alerte Délai :</strong> Si validation après demain, livraison repoussée en <strong>Mars</strong>.
                </div>

                <button onClick={() => navigate('/commercial/sign')} style={{ marginTop: 40, padding: '20px 50px', borderRadius: 50, border: 'none', background: 'white', color: 'black', fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer', boxShadow: '0 10px 30px rgba(255,255,255,0.2)' }}>
                    SÉCURISER MA PLACE 🔒
                </button>
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Retour</button>

            <style>{`.animate-pulse-red { animation: pulseRed 2s infinite; } @keyframes pulseRed { 0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4); } 70% { box-shadow: 0 0 0 20px rgba(239, 68, 68, 0); } 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); } }`}</style>
        </div>
    );
}
